// import translationEn from '../en'

import common from './common'
import explore from './explore'
import iconclass from './iconclass'
import navigation from './navigation'
import exhibitions from './exhibitions'
import search from './search'
import filters from './filters'
import dialog from './dialog'
import detail from './detail'
import iconclass_codes from './iconclass_codes'
import editor from './editor'

const translationCs = {
  common,
  explore,
  iconclass,
  navigation,
  exhibitions,
  search,
  filters,
  dialog,
  detail,
  iconclass_codes,
  editor,
}

export default translationCs
